module.exports = __webpack_public_path__ + "img/rocket.82450ace.svg";